import { FormContainer as Container, FormSection as Section } from "../../components";
import { InputField as Input } from "../../components/";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import FormContext from "../../context/FormContext.js";
import { useContext, useEffect } from 'react';

export default function APManual() {
    const { injectFormProps } = useInjectFormProps();
    const { formData, updateFormData } = useContext(FormContext);

    useEffect(() => {
        updateFormData({ "ap-consent-prompt": "I confirm that I have read and agreed with the above information." })
    }, []);

    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"Administrative Procedure Manuals"}>
                        <p>
                            Good Spirit School Division has an Administrative Procedures Manual in place designed to be the primary written source of administrative direction for the division. These procedures provide guidelines which the division, staff and students are to follow.
                        </p>
                        <p>
                            We would like to bring to your attention three (3) specific Administrative Procedures that we would ask you to review with your child in an age-appropriate manner. As all students have access to both technology and transportation services, it is very important to ensure that procedures are in place, and followed, for the safety and efficient usage of these resources.
                        </p>
                        <ul>
                            <li><a href="https://www.gssd.ca/download/389183" target="_blank" rel="noreferrer">AP 140 - Responsible Use of Technology</a></li>
                            <li><a href="https://www.gssd.ca/download/389204" target="_blank" rel="noreferrer">AP 143 - Social Media</a></li>
                            <li><a href="https://www.gssd.ca/download/389599" target="_blank" rel="noreferrer">AP 554 - Student Transportation Code of Conduct</a></li>
                        </ul>
                        <p>
                            I hereby declare that I have read and understood the information contained in the above section and that the information I have provided on this Registration Form is correct. I understand it is my responsibility to inform the school of any changes to the information contained on this form.
                        </p>
                        <p>
                            I, as the parent/legal guardian, hereby grant permission to Good Spirit School Division to create and manage online accounts on behalf of my child, including, but not limited to, Google and Microsoft accounts and associated email addresses.
                        </p>
                        <hr>
                        </hr>
                        <Input type={"checkbox"} inputLabel={formData["ap-consent-prompt"] ?? <i>something went wrong.</i>} identifier={"ap-consent"}></Input>
                    </Section>
                </>
            )}
        </Container>
    );
}
